import Vue from 'vue'
import Cleave from 'cleave.js'

Vue.directive('cleave', {
    bind(el, binding) {
        const input = el.querySelector('input')
        // @ts-ignore
        input._vCleave = new Cleave(input, binding.value)
    },
    update: (el) => {
        const input = el.querySelector('input')
        const event = new Event('input', {bubbles: true});
        setTimeout(function () {
            input.value = input._vCleave.properties.result
            input.dispatchEvent(event)
        }, 100);
    },
    unbind(el) {
        const input = el.querySelector('input')
        // @ts-ignore
        input._vCleave.destroy()
    }    
})

Vue.prototype.$cleave = {
    masks: {
        phone: {
            delimiters: ['(', ') '],
            blocks: [0, 2, 9],
            numericOnly: true
        },
        cpf: {
            blocks: [11],
            numericOnly: true
        },
        date: {
            date: true,
            datePattern: ['d', 'm', 'Y']
        }
    }
}